var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.plan
    ? _c("div", { class: `card ${_vm.planColor} roomy header` }, [
        _c(
          "span",
          {
            staticClass: "tag primary size-lg",
            staticStyle: {
              "--tag-padding":
                "var(--spacing-2xs) var(--spacing-xs) var(--spacing-2xs) var(--spacing-sm)",
            },
          },
          [_vm._v(_vm._s(_vm.planName))]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "text-left margin-top-xl display-flex flex-column" },
          [
            _c("p", [_vm._v(_vm._s(_vm.description))]),
            _vm._v(" "),
            _c(
              "ul",
              {
                class: ["fa-ul", { "margin-y-xs": _vm.allIconPacks }],
                staticStyle: {
                  "--list-item-margin-bottom": "var(--spacing-sm)",
                },
              },
              [
                _vm.allIconPacks
                  ? _c("li", [
                      _c(
                        "span",
                        { staticClass: "fa-li" },
                        [
                          _c("font-awesome-icon", {
                            attrs: { icon: _vm.$v7.solid.faIcons },
                          }),
                        ],
                        1
                      ),
                      _vm._v("\n        Access to ALL Icon Packs\n      "),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.allIconPacks
                  ? _c("li", [
                      _c(
                        "span",
                        { staticClass: "fa-li" },
                        [
                          _c("font-awesome-icon", {
                            attrs: { icon: _vm.$v7.solid.faShapes },
                          }),
                        ],
                        1
                      ),
                      _vm._v("\n        New Pro+ Icon Packs\n      "),
                    ])
                  : _c("li", [
                      _c(
                        "span",
                        { staticClass: "fa-li" },
                        [
                          _c("font-awesome-icon", {
                            attrs: { icon: _vm.$v7.solid.faIcons },
                          }),
                        ],
                        1
                      ),
                      _vm._v("\n        Core Pro Icon Packs\n      "),
                    ]),
                _vm._v(" "),
                _c("li", [
                  _c(
                    "span",
                    { staticClass: "fa-li" },
                    [
                      _c("font-awesome-icon", {
                        attrs: { icon: _vm.$v7.solid.faGrid2Plus },
                      }),
                    ],
                    1
                  ),
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.plan.customIcons) +
                      " Custom Icons\n      "
                  ),
                ]),
                _vm._v(" "),
                _c("li", [
                  _c(
                    "span",
                    { staticClass: "fa-li" },
                    [
                      _c("font-awesome-icon", {
                        attrs: { icon: _vm.$v7.solid.faSuitcase },
                      }),
                    ],
                    1
                  ),
                  _vm._v(
                    "\n        " + _vm._s(_vm.plan.kits) + " Kits\n      "
                  ),
                ]),
                _vm._v(" "),
                _c("li", [
                  _c(
                    "span",
                    { staticClass: "fa-li" },
                    [
                      _c("font-awesome-icon", {
                        attrs: { icon: _vm.$v7.solid.faSignalBars },
                      }),
                    ],
                    1
                  ),
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.formatNumber(_vm.plan.monthlyPageviews)) +
                      " Pageviews\n      "
                  ),
                ]),
              ]
            ),
            _vm._v(" "),
            _c(
              "site-link",
              {
                staticClass: "button flat block with-border",
                style: `--link-color: var(--fa-navy); --border-color: var(--fa-dk-${_vm.planColor}); --button-margin-bottom: 0; margin-top: var(--spacing-sm)`,
                attrs: {
                  to: { name: "plans", query: { plans: _vm.planTier } },
                },
                nativeOn: {
                  click: function ($event) {
                    return _vm.$posthog.capture("upgrade_link_click", {
                      context: "home_view",
                    })
                  },
                },
              },
              [_vm._v("See All " + _vm._s(_vm.planName) + " Plans")]
            ),
          ],
          1
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }